import { useCustomerAgentHover } from '../../contexts/CustomerAgentHoverContext';
import { LEFT_ALIGNED } from '../constants/WidgetLocations';
import { FocusScope } from 'react-aria';
import styled from 'styled-components';
import { useInitialPromptsAccessibility } from '../../hooks/useInitialPromptsAccessibility';
import InitialPageContentWrapperV2 from './InitialPageContentWrapperV2';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledInitialPageContentWrapper = styled.div.withConfig({
  displayName: "InitialPageContentWrapper__StyledInitialPageContentWrapper"
})(["display:flex;flex-direction:column;gap:8px;align-items:", ";margin:", ";"], ({
  widgetLocation
}) => widgetLocation === LEFT_ALIGNED ? 'flex-start' : 'flex-end', ({
  showPillLauncher,
  usePillLauncher,
  isMobile
}) => {
  if (isMobile) {
    return '0px';
  }
  if (showPillLauncher) {
    return '15px';
  }
  if (usePillLauncher) {
    return '18px';
  }
  return '0px';
});
const InitialPageContentWrapper = ({
  children,
  widgetLocation,
  showPillLauncher,
  shouldTrapFocus,
  isMobile = false,
  usePillLauncher = false,
  isUngatedForLauncherExperience = false
}) => {
  const {
    setIsHoverActive
  } = useCustomerAgentHover();
  const {
    interactionProps,
    shouldContainFocus
  } = useInitialPromptsAccessibility({
    shouldTrapFocus,
    onHoverChange: setIsHoverActive
  });
  if (isUngatedForLauncherExperience) {
    return /*#__PURE__*/_jsx(InitialPageContentWrapperV2, {
      widgetLocation: widgetLocation,
      showPillLauncher: showPillLauncher,
      isMobile: isMobile,
      usePillLauncher: usePillLauncher,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(StyledInitialPageContentWrapper, Object.assign({
    "data-test-id": "initial-page-content-wrapper"
  }, interactionProps, {
    widgetLocation: widgetLocation,
    showPillLauncher: showPillLauncher,
    isMobile: isMobile,
    usePillLauncher: usePillLauncher,
    children: /*#__PURE__*/_jsx(FocusScope, {
      contain: shouldContainFocus,
      restoreFocus: true,
      children: children
    })
  }));
};
InitialPageContentWrapper.displayName = 'InitialPageContentWrapper';
export default InitialPageContentWrapper;